import { getAuthSession, redirectToFirmFrontendLogin } from 'auth/session';
import { AuthUserDispatcher } from 'auth/AuthUserDispatcher';
import Main from './Main_updated';

const PrivateRoute = () => {
  const isAuthenticated = getAuthSession();

  if (!isAuthenticated) {
    redirectToFirmFrontendLogin();
    return null;
  }

  return (
    <AuthUserDispatcher>
      <Main />
    </AuthUserDispatcher>
  );
};

export default PrivateRoute;
